import { ALL_SUPPORTED_CHAINS } from '~/constants/chain'
import { RUNTIME_ENV } from '~/constants/env'

export const useNetworkOptions = () => {
  let networks = ALL_SUPPORTED_CHAINS
  return networks.filter((chain) => chain.matchedEnv.includes(RUNTIME_ENV))
}
